import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom"
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Textarea from '@mui/joy/Textarea';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import FundService from "../../../services/fundService";


function ModalFCIComments( {handleOpen, isOpen, selected, handleSelected, fundId, doSearch}) {

    const navigate = useNavigate();

    const doSaveComments = async () => {
        FundService.putFundAuthComments(selected.id, {note: selected.note})
            .then(function(response){
                toast.success('Comentario Actualizado!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            })
            .catch(function (error) { 
                if(error.response.status !== 401){
                    Swal.fire({
                        title: 'Ooops?',
                        text: error.response.data.errors[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            })
            .finally(() => { 
                handleOpen(false) 
                doSearch()
            })
    }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Comentarios: #{fundId}</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>                        
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Comentarios</FormLabel>
                                <Textarea
                                    onChange={(e) => handleSelected({...selected, note: e.target.value})}
                                    value={selected.note}
                                    minRows={4}
                                    maxRows={4}
                                />
                            </FormControl>
                        </Grid>
                        
                    </Grid> 
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info"  onClick={() => doSaveComments()}> Guardar </button>                    
                    <button type="button" className="btn btn-outline-secondary"  onClick={() => handleOpen(false)}> Cerrar </button>                    
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalFCIComments;